<template>
  <Section :content="search" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionSearch',
  components: {
    Section,
  },
  data() {
    return {
      search: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Find the needle in the haystack',
        paragraphs: [
          'Easily find information stored inside thousands of documents. Instead of hundreds of search results, you pinpoint your results down to a handful of Units-of-Thought that contain your multiple search words.',
          'Trinity will transform both raster (pictures/scans) and vector PDFs to IntelligentPDF\u2122.'
        ],
        id: 'find-needle',
        image: 'crosslink-search-results-crop.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
        /*html: 
          '<div>' + 
          ' <h5 class="mb-4">Easily find information stored inside thousands of documents. Instead of hundreds of search results, you pinpoint your results down to a handful of Units-of-Thought that contain your multiple search words.' + 
          ' <h5 class="mb-4">Trinity will transform both raster (pictures/scans) and vector PDFs to IntelligentPDF\u2122.</h5>' + 
          '</div>'*/
      }
    }
  }
};
</script>
